import { render, staticRenderFns } from "./artificialRecord.vue?vue&type=template&id=67887642"
import script from "./artificialRecord.vue?vue&type=script&lang=js"
export * from "./artificialRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports